module.exports = __webpack_public_path__ + "assets/b1ff0cca3182e42b54b242c4e19b0b6d.mp4";